<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center">TO<br/>
<br/>
<span class="large">MR. AND MRS. THOMAS E. NEWBOLD</span><br/>
<br/>
THIS YARN IS SPUN WITH INFINITE AFFECTION</p>
</div>
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak">CONTENTS</h2>
</div>
<table>
<tbody><tr><td class="tdr"><span class="allsmcap">CHAPTER</span></td>
<td class="tdr" colspan="2"><span class="allsmcap">PAGE</span></td>
</tr>
<tr><td class="tdr">I.</td>
<td> <span class="smcap">Visions</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h6.htm#Page_1">      1</a></td>
</tr>
<tr><td class="tdr">II.</td>
<td> <span class="smcap">Tragedy</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h7.htm#Page_8">      8</a></td>
</tr>
<tr><td class="tdr">III.</td>
<td> <span class="smcap">Testimony</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h8.htm#Page_23">      23</a></td>
</tr>
<tr><td class="tdr">IV.</td>
<td> <span class="smcap">More Testimony</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h9.htm#Page_40">      40</a></td>
</tr>
<tr><td class="tdr">V.</td>
<td> <span class="smcap">Dorothy Deane, “Society Editor”</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h10.htm#Page_66">      66</a></td>
</tr>
<tr><td class="tdr">VI.</td>
<td> <span class="smcap">The Wall Between</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h11.htm#Page_81">      81</a></td>
</tr>
<tr><td class="tdr">VII.</td>
<td> <span class="smcap">At Thornedale Lodge</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h12.htm#Page_98">      98</a></td>
</tr>
<tr><td class="tdr">VIII.</td>
<td> <span class="smcap">Many Inventions</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h13.htm#Page_114">      114</a></td>
</tr>
<tr><td class="tdr">IX.</td>
<td> <span class="smcap">In the Attic</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h14.htm#Page_138">      138</a></td>
</tr>
<tr><td class="tdr">X.</td>
<td> <span class="smcap">The Black-Edged Card</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h15.htm#Page_154">      154</a></td>
</tr>
<tr><td class="tdr">XI.</td>
<td> <span class="smcap">Mrs. Porter Grows Inquisitive</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h16.htm#Page_170">      170</a></td>
</tr>
<tr><td class="tdr">XII.</td>
<td> <span class="smcap">Detective Mitchell Asks Questions</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h17.htm#Page_186">      186</a></td>
</tr>
<tr><td class="tdr">XIII.</td>
<td> <span class="smcap">The Red Herring</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h18.htm#Page_205">      205</a></td>
</tr>
<tr><td class="tdr">XIV.</td>
<td> <span class="smcap">Pro and Con</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h19.htm#Page_224">      224</a></td>
</tr>
<tr><td class="tdr">XV.</td>
<td> <span class="smcap">Edged Tools</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h20.htm#Page_243">      243</a></td>
</tr>
<tr><td class="tdr">XVI.</td>
<td> <span class="smcap">Hare and Hounds</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h21.htm#Page_259">      259</a></td>
</tr>
<tr><td class="tdr">XVII.</td>
<td> <span class="smcap">Vera Receives a Letter</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h22.htm#Page_279">      279</a></td>
</tr>
<tr><td class="tdr">XVIII.</td>
<td> <span class="smcap">The Counterfeit Bank Note</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h23.htm#Page_293">      293</a></td>
</tr>
<tr><td class="tdr">XIX.</td>
<td> <span class="smcap">The First Shot</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h24.htm#Page_313">      313</a></td>
</tr>
<tr><td class="tdr">XX.</td>
<td> KA</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h25.htm#Page_322">      322</a></td>
</tr>
<tr><td class="tdr">XXI.</td>
<td> <span class="smcap">Blind Man’s Buff</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h26.htm#Page_329">      329</a></td>
</tr>
<tr><td class="tdr">XXII.</td>
<td> “<span class="smcap">The Moving Finger Writes</span>—”</td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h27.htm#Page_344">      344</a></td>
</tr>
<tr><td class="tdr">XXIII.</td>
<td> <span class="smcap">Out of the Maze</span></td>
<td class="tdr"><a class="pginternal" href="#/3186253215635795556_74210h28.htm#Page_352">      352</a></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-4.htm.vue?d82a19dc